import React, { useState, useEffect } from "react";
import AnimatedLetters from "../AnimatedLetters";
import MwalimuPlus from "../../assets/images/projectsDone/MP_Parent.webp";
import School from "../../assets/images/projectsDone/MP_school.webp";
import AjiraTracking from "../../assets/images/projectsDone/Ajira_connect.webp";
import AjiraPro from "../../assets/images/projectsDone/Ajira_pro.webp";
import AjiraAgent from "../../assets/images/projectsDone/Ajira_tracking_agent.webp";
import Coolr from "../../assets/images/projectsDone/coolrgroup.png";
import CoolriOS from "../../assets/images/projectsDone/coolRiOS.png";
import MoneyPhone from "../../assets/images/projectsDone/moneyPhone.png";
import UsafiSasa from "../../assets/images/projectsDone/UsafiSasa.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faMobileAlt, faDesktop, faDatabase, faMapMarkerAlt, faRobot, faRecycle, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import "./index.scss";

const projects = [
  {
    key: 1,
    icon: <img src={MwalimuPlus} alt="MwalimuPlus" className="projectImg" />,
    date: "2020 - Present",
    category: "E-Tech Mobile App (App offline online app)",
    description: "E-learning App for iOS and Android with comprehensive educational resources and interactive learning features.",
    name: "MwalimuPlus (Android)",
    link: "https://play.google.com/store/apps/details?id=com.mwalimuplus",
    iconType: "mobile",
    tech: ["React Native", "Firebase", "Redux", "watermelonDB"],
  },
  {
    key: 2,
    icon: <img src={School} alt="MwalimuPlus School" className="projectImg" />,
    date: "2022 - Present",
    category: "E-Tech Mobile",
    description: "Educational mobile app specifically designed for schools with attendance tracking and performance monitoring.",
    name: "MwalimuPlus School Mobile App",
    link: "https://play.google.com/store/apps/details?id=com.mwalimuplus.school",
    iconType: "mobile",
    tech: ["React Native", "Node.js", "MongoDB"],
    featured: true
  },
  {
    key: 3,
    icon: <img src={AjiraTracking} alt="Ajira Tracking" className="projectImg" />,
    date: "2023 - 2024",
    category: "GPS Tracking System",
    description: "Real-time GPS tracking platform with speed monitoring and location history features for fleet management.",
    name: "Ajira Speed Governor Client",
    link: "https://play.google.com/store/apps/details?id=com.speedgovernor.client",
    iconType: "gps",
    tech: ["React Native", "Google Maps API", "WebSocket"],
    featured: true
  },
  {
    key: 4,
    icon: <img src={MwalimuPlus} alt="MwalimuPlus Web" className="projectImg" />,
    date: "2021",
    category: "E-Learning Platform",
    description: "Web-based learning management system with course management, assessments, and progress tracking.",
    name: "MwalimuPlus Web Platform",
    link: "https://account.mwalimuplus.com/site/login",
    iconType: "web",
    tech: ["Yii2 PHP", "MySQL", "JavaScript"],
    featured: true
  },
  {
    key: 5,
    icon: <img src={AjiraPro} alt="Ajira Connect Pro" className="projectImg" />,
    date: "2020",
    category: "On-Demand Service App",
    description: "Professional service request platform connecting clients with verified service providers.",
    name: "Ajira Connect Professional",
    link: "#",
    iconType: "mobile",
    tech: ["React Native", "Node.js", "PostgreSQL"]
  },
  {
    key: 6,
    icon: <img src={AjiraAgent} alt="Ajira Connect Agent" className="projectImg" />,
    date: "2020-2021",
    category: "Service Provider Panel",
    description: "Administrative panel for service agents to manage requests, schedules, and client interactions.",
    name: "Ajira Connect Agent Panel",
    link: "#",
    iconType: "web",
    tech: ["React.js", "Express.js", "MySQL"]
  },
  {
    key: 7,
    icon: <img src={Coolr} alt="CoolR Group" className="projectImg" />,
    date: "2022",
    category: "AI-Powered Tracking",
    description: "Smart fridge monitoring application with AI-powered expiration tracking and inventory management.",
    name: "CoolR Group (Android)",
    link: "https://play.google.com/store/apps/details?id=com.coolrgroup.devicemanager",
    iconType: "ai",
    tech: ["React Native", "TensorFlow.js", "Firebase"],
    featured: true
  },
  {
    key: 8,
    icon: <img src={CoolriOS} alt="CoolR iOS" className="projectImg" />,
    date: "2022",
    category: "AI-Powered Tracking",
    description: "iOS version of the smart fridge monitoring app with seamless Apple ecosystem integration.",
    name: "CoolR Group (iOS)",
    link: "https://play.google.com/store/apps/details?id=com.coolrgroup.devicemanager",
    iconType: "mobile",
    tech: ["React Native", "Core ML", "Firebase"]
  },
  {
    key: 9,
    icon: <img src={UsafiSasa} alt="UsafiSasa" className="projectImg" />,
    date: "2022-2023",
    category: "Environmental Tech",
    description: "Garbage management app promoting recycling and proper waste disposal practices.",
    name: "Taraka Waste Management",
    link: "#",
    iconType: "environment",
    tech: ["React Native", "Node.js", "MongoDB"]
  },
  {
    key: 10,
    icon: <img src={MoneyPhone} alt="MoneyPhone" className="projectImg" />,
    date: "2025-2026",
    category: "FinTech Mobile Banking",
    description: "Secure mobile banking app enabling self-registration, bill payments, peer-to-peer transfers, merchant payments, and access to EEF bank accounts.",
    name: "MoneyPhone",
    link: "https://play.google.com/store/apps/details?id=io.eclectics.eef.moneyphone",
    iconType: "fintech",
    tech: ["React Native", "Node.js", "REST APIs", "Secure Auth"],
    featured: true
  },
];

const getCategoryIcon = (iconType) => {
  switch(iconType) {
    case 'mobile':
      return <FontAwesomeIcon icon={faMobileAlt} className="category-icon" />;
    case 'web':
      return <FontAwesomeIcon icon={faDesktop} className="category-icon" />;
    case 'gps':
      return <FontAwesomeIcon icon={faMapMarkerAlt} className="category-icon" />;
    case 'ai':
      return <FontAwesomeIcon icon={faRobot} className="category-icon" />;
    case 'environment':
      return <FontAwesomeIcon icon={faRecycle} className="category-icon" />;
    case 'fintech':
      return <FontAwesomeIcon icon={faCreditCard} className="category-icon" />;
    default:
      return <FontAwesomeIcon icon={faDatabase} className="category-icon" />;
  }
};

function Projects() {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [filter, setFilter] = useState("all");
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  const linksClick = (link, e) => {
    e.stopPropagation();
    if (link && link !== "#") {
      window.open(link, "_blank");
    }
  };

  const filteredProjects = filter === "all" 
    ? projects 
    : projects.filter(project => 
        project.category.toLowerCase().includes(filter.toLowerCase()) ||
        project.tech.some(tech => tech.toLowerCase().includes(filter.toLowerCase()))
      );

  const categories = [...new Set(projects.map(p => p.category))];
  const visibleProjects = filteredProjects.slice(0, visibleCount);

  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 3, filteredProjects.length));
  };

  return (
    <div className="container projectContainer">
      <div className="text-zone">
        <h1>
          <AnimatedLetters
            letterClass={letterClass}
            strArray={["P", "r", "o", "j", "e", "c", "t", "s", " ", "D", "o", "n", "e", "."]}
            idx={15}
          />
        </h1>
        <p className="subtitle">Showcasing professional projects across various domains including FinTech, E-Learning, and Enterprise Solutions</p>
      </div>

      {/* Filter Buttons */}
      <div className="filter-buttons">
        <button 
          className={`filter-btn ${filter === "all" ? "active" : ""}`}
          onClick={() => {
            setFilter("all");
            setVisibleCount(6);
          }}
        >
          All Projects
        </button>
        {categories.map((category, index) => (
          <button
            key={index}
            className={`filter-btn ${filter === category.toLowerCase() ? "active" : ""}`}
            onClick={() => {
              setFilter(category.toLowerCase());
              setVisibleCount(6);
            }}
          >
            {category.split(" ")[0]}
          </button>
        ))}
      </div>
      
      <div className="projects-grid">
        {visibleProjects.map((project) => (
          <div
            key={project.key}
            className={`project-card ${project.featured ? 'featured' : ''}`}
            onClick={(e) => linksClick(project.link, e)}
          >
            <div className="project-header">
              <div className="project-image">
                {project.icon}
                {project.featured && (
                  <div className="featured-badge">
                    <FontAwesomeIcon icon={faCreditCard} />
                  </div>
                )}
              </div>
              <div className="project-meta">
                <span className="project-date">{project.date}</span>
                <div className="project-category">
                  {getCategoryIcon(project.iconType)}
                  <span>{project.category}</span>
                </div>
              </div>
              {project.link && project.link !== "#" && (
                <FontAwesomeIcon 
                  icon={faExternalLinkAlt} 
                  className="external-link"
                  onClick={(e) => linksClick(project.link, e)}
                />
              )}
            </div>
            
            <div className="project-content">
              <h3>{project.name}</h3>
              <p className="project-description">{project.description}</p>
              
              <div className="tech-stack">
                {project.tech.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
              
              <div className="project-footer">
                {project.link && project.link !== "#" ? (
                  <button 
                    className="project-link-btn"
                    onClick={(e) => linksClick(project.link, e)}
                  >
                    View Live Project
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                  </button>
                ) : (
                  <span className="coming-soon">Available Soon</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {visibleCount < filteredProjects.length && (
        <div className="load-more-container">
          <button className="load-more-btn" onClick={loadMore}>
            Load More Projects
            <span className="project-count">({filteredProjects.length - visibleCount} remaining)</span>
          </button>
        </div>
      )}
      <div className="projects-summary">
        <div className="summary-card">
          <h4>Projects Summary</h4>
          <div className="summary-stats">
            <div className="stat">
              <span className="stat-number">{projects.length}</span>
              <span className="stat-label">Total Projects</span>
            </div>
            <div className="stat">
              <span className="stat-number">{projects.filter(p => p.featured).length}</span>
              <span className="stat-label">Featured</span>
            </div>
            <div className="stat">
              <span className="stat-number">{projects.filter(p => p.link !== "#").length}</span>
              <span className="stat-label">Live Projects</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;